import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Component/axiosInstance";

// Async thunk for updating a blog post
export const updateblog = createAsyncThunk('updateblog', async (data , { rejectWithValue }) => {
    try {
        // console.log(data.data._id)   
        // return ;
        const response = await axiosInstance.put(`/blog/updateBlogData/${data._id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'x-auth-token': localStorage.getItem("token")
            }
        });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "An unexpected error occurred");
    }
});

// Slice definition
const updateblogslice = createSlice({
    name: 'updateblog',
    initialState: {
        loading: false,
        data: null,
        error: false,
        isError: false,
        isSucces: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(updateblog.pending, (state) => {
                state.loading = true;
                state.isError = false;
                state.isSucces = false;
                state.error = false;
                state.data = null;
            })
            .addCase(updateblog.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.isError = false;
                state.error = false;
                state.isSucces = true;
            })
            .addCase(updateblog.rejected, (state, action) => {
                state.loading = false;
                state.data = null;
                state.error = action.payload || action.error.message;
                state.isError = true;
                state.isSucces = false;
            });
    }
});

export default updateblogslice.reducer;
